import { z } from 'zod';

export const step1Schema = z.object({
  name: z.string().min(1, { message: 'Required' }),
  team: z.array(z.union([z.number(), z.string()])),
});

export const step2Schema = step1Schema.extend({
  copy_from_template: z.string().optional(),
  copy_from_submission: z.string().optional(),
});

export const step2SchemaRefined = step2Schema.refine((data) => data.copy_from_template ?? data.copy_from_submission);

export const step3Schema = step2Schema.extend({
  branding_id: z.string().optional(),
});
